import * as fromActions from '../actions/api.actions';
import { ApiState, StoreAction } from '../../models/rootState.model';


const API_INITAL_STATE: ApiState = {
    online: null,
    count: 0,
    consecutives: 0,
    error: null
}

export function ApiReducer(
    state = API_INITAL_STATE,
    action: StoreAction
): ApiState {

    switch (action.type) {

        case fromActions.API_ACTION_TYPES.API_ONLINE: {
            return {
                ...state,
                online: true,
                consecutives: 0,
                error: null
            }
        }

        case fromActions.API_ACTION_TYPES.API_OFFLINE: {
            return {
                ...state,
                consecutives: state.consecutives++,
                online: false,
                error: action.payload
            }
        }

        default: {
            return state;
        }
    }
}